import {Call} from "../../store/features/calls/callsService";
import {OnGoingCall} from "./onGoingCall";

interface OnGoingCallsProps {
    calls: Call[];
}

export default function OnGoingCalls({calls}: OnGoingCallsProps) {
    if (calls.length === 0) return null;
    return (
        <div aria-label="Calls in progress" role="group" className="flex flex-col gap-1 pb-1">
            {calls.map((call) => <OnGoingCall key={call.callId} call={call}/>)}
        </div>
    );
}
